/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Editor_TitleInputs */

const cs_templates_editor_title = /** @type {(inputs: Templates_Editor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor šablon`)
};

const en_templates_editor_title = /** @type {(inputs: Templates_Editor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template editor`)
};

/**
* | output |
* | --- |
* | "Template editor" |
*
* @param {Templates_Editor_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_editor_title = /** @type {((inputs?: Templates_Editor_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Editor_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_editor_title(inputs)
	return cs_templates_editor_title(inputs)
});